const TransportMode = [
  {
    label: "Air Freight LSE",
    value: "Air Freight LSE",
    type: 0,
  },
  {
    label: "Air Freight ULD",
    value: "Air Freight ULD",
    type: 1,
  },
  {
    label: "Sea Freight LCL",
    value: "Sea Freight LCL",
    type: 0,
  },
  {
    label: "Sea Freight FCL",
    value: "Sea Freight FCL",
    type: 1,
  },
  {
    label: "Sea Break Bulk",
    value: "Sea Break Bulk",
    type: 0,
  },
  {
    label: "Sea Roll On/Roll OFF",
    value: "Sea Roll On/Roll OFF",
    type: 1,
  },
  {
    label: "Sea Liquid",
    value: "Sea Liquid",
    type: 1,
  },
  {
    label: "Road Freight LCL/LTL",
    value: "Road Freight LCL/LTL",
    type: 0,
  },
  {
    label: "Road Freight FCL",
    value: "Road Freight FCL",
    type: 1,
  },
  {
    label: "Road Freight FTL",
    value: "Road Freight FTL",
    type: 1,
  },
  {
    label: "Rail Freight LCL",
    value: "Rail Freight LCL",
    type: 0,
  },
  {
    label: "Rail Freight FCL",
    value: "Rail Freight FCL",
    type: 1,
  },
  {
    label: "Rail Freight FWL",
    value: "Rail Freight FWL",
    type: 1,
  },
  {
    label: "Courier",
    value: "Courier",
    type: 0,
  },
];
export default TransportMode;
